<template>
  <div>
    <div class="dev-overlay" :class="{ hideOverlay: devButtonHide}">
      <div class="stickbutton" v-on:click="toggleDev">{{ devButtonText }}</div>
      <div class="flex-top">
        <div>
          <div><router-link to="/test">test page</router-link></div>
          <div>
            route: {{ $route.path }} : {{ $route.name }}
          </div>
          <small-button v-on:click="handleShowUpload">Upload</small-button>
          <small-button v-on:click="handleLogOut" v-show="$store.state.signedInAdmin">Log out</small-button>
        </div>
        <div style="width:45%">
          <div>{{ $store.state.devMessage }}</div>
          <div>
            <div>Editing</div> <on-off-button v-model="editing" />
            <div v-on:click="handlePush">Push</div>
          </div>
        </div>
      </div>
    </div>
     <upload-component v-if="showUpload" v-on:close="handleHideUpload" />
  </div>
</template>

<script>

import OnOffButton from '@/components/buttons/OnOffButton.vue'

export default {
  components: {
    OnOffButton,
    'upload-component' : () => import(/* webpackChunkName: "editor" */ '@/components/editors/UploadComponent.vue'),
  },
  data: function () {
    return {
      devButtonHide: false,
      width: 0,
      height: 0,
      breakpoint: {},
      showUpload: false
    }
  },
  created: function () {
    if(localStorage.devButtonHide) {
      this.devButtonHide = (localStorage.devButtonHide === 'true')
    }
  },
  computed: {
    devButtonText: function () {
      if(this.devButtonHide) return "DEV-BAR"
      return "HIDE"
    },
    editing: {
      get: function () {
        return this.$store.state.editing
      },
      set: function (val) {
        this.$store.commit('setEditing', val);
      }
    }
  },
  methods: {
    handlePush () {
      history.pushState('','','/about')
    },
    handleLogOut: async function () {
      this.$router.push('/login')
    },
    toggleDev: function () {
      this.devButtonHide = !this.devButtonHide
    },
    handleResize: async function () {
      this.width = window.innerWidth
      this.height = window.innerHeight
      this.breakpoint = this.$k.getBreakpoint()
    },
    handleShowUpload () {
      this.showUpload = true
    },
    handleHideUpload () {
      this.showUpload = false
    }

  },
  mounted: function () {
    window.addEventListener('resize', () => {
      this.handleResize()
    })
    window.addEventListener('scroll', () => {
      this.scrollY = Math.round(window.scrollY)
    })
    this.handleResize()
  },
  watch: {
    devButtonHide: function () {
      localStorage.devButtonHide = JSON.stringify(this.devButtonHide)
    }
  }
}
</script>

<style scoped>
.dev-overlay{
  background-color:rgba(0,0,0,0.8);
  box-sizing:border-box;
  padding:10px;
  position:fixed;
  bottom: 0;
  left:10vw;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  color:#fff;
  transition: all 0.3s ease;
  border:1px solid rgba(255,255,255,0.5);
  border-bottom: none;
  font-size:12px;
  z-index:1000;
}

.dev-overlay .stickbutton{
  position:absolute;
  box-sizing:border-box;
  top:0;
  left:16px;
  padding:6px 12px;
  color:#fff;
  font-weight:400;
  transform: translateY(-100%);
  background-color:rgba(0,0,0,0.9);
  font-size:10px;
  cursor:pointer;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
  border:1px solid rgba(255,255,255,0.5);
  border-bottom: none;
  
}

.dev-overlay .stickbutton:hover{
  color:#ce0e2d;
  background-color:#000;
}

.dev-overlay.hideOverlay{
  transform:translateY(100%);
}

.dev-overlay a{
  display:inline-block;
  color:#fff;
  text-decoration:none;
  padding:0 10px;
}

.dev-overlay a:hover{
  color:red;
  text-decoration: underline;
  
}

.flex-top{
  display:flex;
}
</style>
